/**
 * verse/whispers/types.ts — Shared helpers for whisper libraries
 *
 * Each operator's text content lives in its own file under whispers/.
 * This module provides the small utilities they all need — capitalization,
 * random selection, article choice — so no whisper file reimplements them.
 */

/** Capitalize first letter of a string */
export function cap(s: string): string {
  if (!s) return s;
  return s[0].toUpperCase() + s.slice(1);
}

/** Pick one item from an array using a seeded PRNG */
export function pick<T>(arr: T[], rand: () => number): T {
  return arr[Math.floor(rand() * arr.length)];
}

/** Relational nouns that take "Your" instead of "The" */
const RELATIONAL_NOUNS = new Set([
  "mom", "mother", "dad", "father", "brother", "sister", "friend",
  "son", "daughter", "husband", "wife", "partner",
  "grandma", "grandmother", "grandpa", "grandfather", "baby", "child",
]);

/** "Your mom" not "The mom" */
export function articleFor(word: string): string {
  return RELATIONAL_NOUNS.has(word) ? "Your" : "The";
}

/** Indefinite article ("a" / "an") based on leading letter */
export function indefArticle(word: string): string {
  return /^[aeiou]/i.test(word) ? "an" : "a";
}
